// Muss in den jeweiligen Modulen importiert werden mit:
// import rules from '@/store/rules'
import i18n from "@/plugins/i18n";

export default {
	optionalStringMax35Rule: [
		(v: string) => v.length <= 35 || (i18n.t("store.rules.maxLength35") as string),
	],
	requiredRule: [
		(v: string) => !!v || (i18n.t("store.rules.requiredTrailingSpace") as string),
		(v: string) =>
			!v ||
			v.replace(/\s/g, "").length > 0 ||
			(i18n.t("store.rules.onlyWhitespace") as string),
	],
	addressOptionalStringMax35Rule: [
		(v: string) => v.length <= 35 || (i18n.t("store.rules.maxLength35") as string),
		(v: string) =>
			!/[\*\^\\\{\}\[\]\=\>\<\|]/.test(v) || (i18n.t("store.rules.invalidCharacters") as string),
	],
	optionalStringMax50Rule: [
		(v: string) => v.length <= 50 || (i18n.t("store.rules.maxLength50") as string),
	],
	requiredStringMax35Rule: [
		(v: string) => !!v || (i18n.t("store.rules.required") as string),
		(v: string) =>
			v.replace(/\s/g, "").length > 0 || (i18n.t("store.rules.onlyWhitespace") as string),
		(v: string) => !v || v.length <= 35 || (i18n.t("store.rules.maxLength35") as string),
	],
	addressRequiredStringMax35Rule: [
		(v: string) => !!v || (i18n.t("store.rules.required") as string),
		(v: string) =>
			v.replace(/\s/g, "").length > 0 || (i18n.t("store.rules.onlyWhitespace") as string),
		(v: string) => !v || v.length <= 35 || (i18n.t("store.rules.maxLength35") as string),
		(v: string) =>
			!/[\*\^\\\{\}\[\]\=\>\<\|]/.test(v) || (i18n.t("store.rules.invalidCharacters") as string),
	],
	requiredStringMax50Rule: [
		(v: string) => !!v || (i18n.t("store.rules.required") as string),
		(v: string) =>
			v.replace(/\s/g, "").length > 0 || (i18n.t("store.rules.onlyWhitespace") as string),
		(v: string) => !v || v.length <= 50 || (i18n.t("store.rules.maxLength50") as string),
	],
	allowedCartAmountRule: [
		(v: number) => !!v || (i18n.t("store.rules.required") as string),
		(v: number) => !isNaN(v) || (i18n.t("store.rules.notANumber") as string),
		(v: number) => v >= 1 || (i18n.t("store.rules.mustBePositive") as string),
		(v: number) => v % 1 === 0 || (i18n.t("store.rules.noDecimals") as string),
	],
	requiredEmailRule: [
		(v: string) => !!v || (i18n.t("store.rules.requiredTrailingSpace") as string),
		(v: string) => v.length <= 50 || (i18n.t("store.rules.maxLength50TrailingSpace") as string),
		(v: string) =>
			/^[^@\s;]+@[^@\s;]+\.[^@\s;]+$/.test(v) || (i18n.t("store.rules.invalidEmail") as string),
	],
	optionalEmailRule: [
		(v: string) =>
			!v ||
			/^[^@\s;]+@[^@\s;]+\.[^@\s;]+$/.test(v) ||
			(i18n.t("store.rules.invalidEmail") as string),
	],
	requiredIntegerRule: [
		(v: number) => !!v || (i18n.t("store.rules.required") as string),
		(v: number) => !isNaN(v) || (i18n.t("store.rules.notANumber") as string),
		(v: string) => parseInt(v) === parseFloat(v) || (i18n.t("store.rules.notAnInteger") as string),
	],
	requiredInteger0To1000Rule: [
		(v: number) => !!v || (i18n.t("store.rules.required") as string),
		(v: number) => !isNaN(v) || (i18n.t("store.rules.notANumber") as string),
		(v: string) => parseInt(v) === parseFloat(v) || (i18n.t("store.rules.notAnInteger") as string),
		(v: number) => (v > 0 && v <= 1000) || (i18n.t("store.rules.outOfRange0To1000") as string),
	],
};
